import * as gdlAPI from "./workspaces/gdl"
import * as dataAPI from "./workspaces/data"
import * as dataApiHealthAPI from "./dataapihealth"
import { Filter, Pagination } from "../components/workspacelistpage"
import { WorkspacesODataResponse } from "./models/workspace"

export const getWorkspaces = (
    filter: Filter,
    pagination: Pagination,
): Promise<WorkspacesODataResponse> => {
    return dataApiHealthAPI.isDataApiHealthy().then((isHealthy) => {
        if (isHealthy) {
            return getWorkspacesFromDataApi(filter, pagination)
        }

        // GdlApi starts from 1 instead of 0
        const requestedPageNumber = pagination.currentPage + 1

        return gdlAPI
            .getGDLData(
                datakey,
                requestedPageNumber,
                getGdlApiFilterParams(filter),
                isPrintView,
            )
            .then(({ pagination: { count }, workspaces }) => ({
                count,
                workspaces,
            }))
    })
}

export const filterWorkspaces = (
    filter: Filter,
    pagination: Pagination,
): Promise<WorkspacesODataResponse> => {
    return dataApiHealthAPI.isDataApiHealthy().then((isHealthy) => {
        if (isHealthy) {
            return getWorkspacesFromDataApi(filter, pagination)
        }

        return gdlAPI
            .applyGDLFilter(datakey, getGdlApiFilterParams(filter), currentPath)
            .then(({ pagination: { count }, workspaces }) => ({
                count,
                workspaces,
            }))
    })
}

////
// GDL API HELPERS
////
const datakey = "workspace"
const isPrintView = false
// This parameter is null for all GDL requests except for the ones concerning the "datahomefolderfiles"
const currentPath = null

// we have to disable the linting because of way the GDL api
// requires the keys in the filter
const getGdlApiFilterParams = (
    filter: Filter,
): Record<string, string | boolean> => ({
    gdlcolumn_IsActive: filter.isActive,
    gdlcolumn_Name: filter.code,
    gdlcolumn_ScreenLabel: filter.label,
})

////
// DATA API HELPERS
////
const getDataApiFilterParams = ({ isActive, label, code }: Filter): string => {
    let filter = `isActive eq ${isActive}`

    if (label.length > 0) {
        filter += ` and contains(label,'${label}')`
    }

    if (code.length > 0) {
        filter += ` and contains(code,'${code}')`
    }

    return filter
}

const getWorkspacesFromDataApi = (
    filter: Filter,
    pagination: Pagination,
): Promise<WorkspacesODataResponse> => {
    const { pageSize, currentPage } = pagination
    const skip = pageSize * currentPage
    const filters = getDataApiFilterParams(filter)

    return dataAPI.getWorkspaces(filters, pageSize, skip)
}
